import useInitializeNewspaperAdvancedSettingForm from './useInitializeNewspaperAdvancedSettingForm'

export default useInitializeNewspaperAdvancedSettingForm
